/* unplugin-vue-components disabled */import script from "./MobileTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileTabBar.vue?vue&type=script&setup=true&lang=js"

import "./MobileTabBar.vue?vue&type=style&index=0&id=0c186568&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c186568"]])

export default __exports__